import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import {IconButton} from "@mui/material";
import {Menu} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import logo from "assets/images/logo_tuG_transparent.png";
import LogoBilling from "assets/images/logo_blanco_billing.png";
import {AvatarButton} from "components/Header/AvatarButton";
import { useSelector } from "react-redux";

const PACK_ENTREPRENEUR = 6

export const Header = (props) => {
  const {barHeight = 50, handleDrawerOpen} = props;
  const pack = useSelector(state => state.planes.pack)

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        height: barHeight,
      }}
    >
      <Toolbar
        disableGutters={true}
        style={{
          backgroundColor: "#921026",
          minHeight: barHeight,
        }}
      >
        <IconButton
          color="inherit"
          aria-label="Open drawer"
          onClick={handleDrawerOpen}
          sx={{marginLeft: 1, marginRight: 1}}
        >
          <Menu
            sx={{transition: (theme)=> theme.transitions.create(["transform"], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen
              }),
              transform: "rotate(180deg)"}}
          />
        </IconButton>
        {
          pack === PACK_ENTREPRENEUR ? <img style={{ objectFit: 'cover', maxWidth: "150px"  }} src={LogoBilling} alt="tugerenteBilling" /> :   <img alt="tuGerente logo" src={logo} style={{ maxWidth: "150px" }} />
        }

        <Typography type="title" color="inherit" style={{ flex: 1 }} align={"right"}>
          <AvatarButton/>
        </Typography>
      </Toolbar>
    </AppBar>
  );
}
